module.exports = __webpack_public_path__ + "static/notify-new-shifts-8a6a22ec17eb29f2686bffbb4e313965.png";